import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 mb-4 bg-slate-200 pl-4"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  disabled: "",
  class: "mt-2 inline-block rounded bg-red-600 px-6 py-2.5 leading-tight text-white shadow-md"
}, " Sold Out ", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Recently minted NFTs", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkGate = _resolveComponent("NetworkGate")!
  const _component_References = _resolveComponent("References")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, "Available: " + _toDisplayString(`${_ctx.mintLimit - _ctx.totalSupply}/${_ctx.mintLimit}`), 1),
    _createVNode(_component_NetworkGate, { expectedNetwork: _ctx.chainId }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Wallet: " + _toDisplayString(_ctx.wallet), 1),
        _createElementVNode("p", null, "Network: " + _toDisplayString(_ctx.network), 1),
        (_ctx.totalBalance > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " You have " + _toDisplayString(_ctx.totalBalance) + " whitelist token(s). ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, "Price: " + _toDisplayString(_ctx.mintPriceString), 1),
        (_ctx.totalSupply < _ctx.mintLimit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.restricted && _ctx.totalBalance == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Sorry, minting is available only to \"" + _toDisplayString(_ctx.restricted) + "\" NFT holders at this moment. ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_ctx.isMinting)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Processing... "))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mint && _ctx.mint(...args))),
                          class: "mt-2 inline-block rounded bg-green-600 px-6 py-2.5 leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg"
                        }, _toDisplayString(_ctx.$t("mint.mint")), 1))
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      ]),
      _: 1
    }, 8, ["expectedNetwork"]),
    (_ctx.tokens.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
            return (_openBlock(), _createElementBlock("span", {
              key: token.tokenId
            }, [
              _createElementVNode("a", {
                href: `${_ctx.OpenSeaPath}/${token.tokenId}`,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: token.image,
                  class: "mr-1 mb-1 inline-block w-32"
                }, null, 8, _hoisted_12)
              ], 8, _hoisted_11)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_References, {
      EtherscanToken: _ctx.EtherscanToken,
      TokenName: _ctx.tokenName
    }, null, 8, ["EtherscanToken", "TokenName"])
  ]))
}